export const formatLocale = ((): ((locale: string, shortName: boolean, displayLocale?: string) => string) => {
	if (!Intl.DisplayNames) {
		return (locale) => locale
	}

	return (locale, shortName, displayLocale) => {
		const displayNames = new Intl.DisplayNames([displayLocale ?? locale ?? 'en'], { type: 'language' })
		if (shortName) return displayNames.of(locale)?.replace(/\(.*\)/, '') ?? locale
		return displayNames.of(locale) ?? locale
	}
})()
